import React from 'react';

import Layout from '@src/layouts';
import SEO from '@commons/SEO';
import { Header } from '@commons/header/Header';

import { SPENEScrollWrapper } from '@pages-impl/spe-ne/spe-ne-scroll-wrapper';
import {
  P4Section,
  FPGASection,
  DPDKSection,
  SmartNICSection,
  OurExperienceSection,
} from '@pages-impl/spe-low-level-programming';

import featuredImage from '@images/header-images/featured_image_og_codilime_low_level_programming.jpg';

export default function SPELowLevelProgramming(props) {
  return (
    <Layout {...props}>
      <SEO
        title="Low-level Software Development Services Company - CodiLime"
        description="CodiLime is a company with experience in low-level programming including DPDK, smartNICs, P4 programming language and FPGA. See how we help."
        featuredImage={featuredImage}
      />
      <Header
        title="Low-level programming"
        aboveTitle="Software product engineering"
        descriptionText="Customizing your software and hardware to your precise needs"
        id="low-level-programming_header"
        src="spe_low-level_header.jpg"
        srcSmall="spe_low-level_header_small.jpg"
      />
      <SPENEScrollWrapper>
        <OurExperienceSection />
        <DPDKSection />
        <SmartNICSection />
        <P4Section />
        <FPGASection />
      </SPENEScrollWrapper>
    </Layout>
  );
}
